import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const solarstep1Reducer = (state = {
    highestpowerUI: [],
    highestbezugpowerUI: [],
    spezifischerGesamtertragUI: [],
    GesamtertragUI: [],
    TagesertragUI: [],
    spezifischerertragUI: [],
    JahresFinanzierungsfortschrittUI: [],
    JahresGesamtstromverbrauchUI: [],

    AktuellerSpezifischerJahresertragUI: [],
    AktuellerGesamtertragJahrUI: [],
    AktuellerSpezifischerMonatsertragUI: [],
    AktuellerMonatsGesamtertragUI: [],
    AktuelleLeistungUI: [],
    AktuellerTagesertragUI: [],
    AktuellerSpezifischerTagesertragUI: [],

    BarDiagrammTageswerteUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_HIGHESTPOWER_solarstep1Reducer":
            return { ...state, highestpowerUI: action.value, isLoaded: true };
        case "RECEIVE_HIGHESTBEZUGPOWER_solarstep1Reducer":
            return { ...state, highestbezugpowerUI: action.value, isLoaded: true };
        case "RECEIVE_SpezifischerGesamtertrag_solarstep1Reducer":
            return { ...state, spezifischerGesamtertragUI: action.value, isLoaded: true };
        case "RECEIVE_Gesamtertrag_solarstep1Reducer":
            return { ...state, GesamtertragUI: action.value, isLoaded: true };
        case "RECEIVE_Tagesertrag_solarstep1Reducer":
            return { ...state, TagesertragUI: action.value, isLoaded: true };
        case "RECEIVE_Spezifischer_solarstep1Reducer":
            return { ...state, spezifischerertragUI: action.value, isLoaded: true };
        case "RECEIVE_JahresFinanzierungsfortschritt_solarstep1Reducer":
            return { ...state, JahresFinanzierungsfortschrittUI: action.value, isLoaded: true };
        case "RECEIVE_JahresGesamtstromverbrauch_solarstep1Reducer":
            return { ...state, JahresGesamtstromverbrauchUI: action.value, isLoaded: true };
        case "RECEIVE_AktuellerSpezifischerJahresertrag_solarstep1Reducer":
            return { ...state, AktuellerSpezifischerJahresertragUI: action.value, isLoaded: true };
        case "RECEIVE_AktuellerGesamtertragJahr_solarstep1Reducer":
            return { ...state, AktuellerGesamtertragJahrUI: action.value, isLoaded: true };
        case "RECEIVE_AktuellerSpezifischerMonatsertrag_solarstep1Reducer":
            return { ...state, AktuellerSpezifischerMonatsertragUI: action.value, isLoaded: true };
        case "RECEIVE_AktuellerMonatsGesamtertrag_solarstep1Reducer":
            return { ...state, AktuellerMonatsGesamtertragUI: action.value, isLoaded: true };
        case "RECEIVE_AktuelleLeistung_solarstep1Reducer":
            return { ...state, AktuelleLeistungUI: action.value, isLoaded: true };
        case "RECEIVE_AktuellerTagesertrag_solarstep1Reducer":
            return { ...state, AktuellerTagesertragUI: action.value, isLoaded: true };
        case "RECEIVE_AktuellerSpezifischerTagesertrag_solarstep1Reducer":
            return { ...state, AktuellerSpezifischerTagesertragUI: action.value, isLoaded: true };
        case "RECEIVE_BarDiagrammTageswerte_solarstep1Reducer":
            return { ...state, BarDiagrammTageswerteUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return {
                ...state,
                highestpowerUI: [],
                highestbezugpowerUI: [],
                spezifischerGesamtertragUI: [],
                GesamtertragUI: [],
                TagesertragUI: [],
                spezifischerertragUI: [],
                JahresFinanzierungsfortschrittUI: [],
                JahresGesamtstromverbrauchUI: [],
                AktuellerSpezifischerJahresertragUI: [],
                AktuellerGesamtertragJahrUI: [],
                AktuellerSpezifischerMonatsertragUI: [],
                AktuellerMonatsGesamtertragUI: [],
                AktuelleLeistungUI: [],
                AktuellerTagesertragUI: [],
                AktuellerSpezifischerTagesertragUI: [],
                BarDiagrammTageswerteUI: [],
                isLoaded: false
            };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default solarstep1Reducer;